var Modal = require("components/utility/AltModal");
var CurrentUser = require('lib/account/CurrentUser');
var WeekLogTable = require('components/reading/logs/WeekLogTable');

var moment = require("moment");

require("users/parents/logs_approval_modal.scss")


class ParentLogsApprovalModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {};
	}

	getFirstDayOfWeek(dateString) {
		var date = moment(dateString, "YYYY-MM-DD");
		if (date.day() < WEEK_START_DAY) {
			var shift = (date.day() + 7) - WEEK_START_DAY;
		} else {
			var shift = date.day() - WEEK_START_DAY;
		}
		var firstDayDate = date.subtract(shift, "days");

		return firstDayDate.format("YYYY-MM-DD");
	}

	render() {
		var weeksMap = _.map(this.props.logs, function(log) {
			var month = this.getFirstDayOfWeek(log.log_date)
			return month
		}.bind(this));
		//this returns a list of all the logs but months repeat, example: 2017-05-01, 2017-05-01

		var uniqueWeeks = _.uniq(weeksMap).sort().reverse();

		var tableWeeks = _.map(uniqueWeeks, function(week) {
			var filteredLogs = _.filter(this.props.logs, function(log){
				return this.getFirstDayOfWeek(log.log_date) == week;
			}.bind(this));

			return (
				<WeekLogTable logs={ filteredLogs } week={ week } key={ week }
					logsApproval={ true } onLogVerification={ this.props.onLogVerification } />
			);

		}.bind(this));


		return (
			<Modal className="logsApprovalModal" preventHide={ true } 
				headerText="Verify Reading Logs" ref="modal">
				<p className="instructionsText">
					Please review and sign off on { this.props.student.first_name }'s reading logs 
					so that your child will get credit for their reading.
				</p>
				{ tableWeeks }
			</Modal>
		)
	}
	componentDidMount() {
		this.refs.modal.show();
	}
}


ParentLogsApprovalModal.propTypes = PageStrictPropTypes({
	student: PropTypes.object.isRequired,
	logs: PropTypes.array.isRequired,
	onUpdateLog: PropTypes.func.isRequired,
	onLogVerification: PropTypes.func.isRequired

});

var WEEK_START_DAY = 1;

module.exports = ParentLogsApprovalModal


// WEBPACK FOOTER //
// ./modules/components/users/parents/ParentLogsApprovalModal.js